module.exports = __webpack_public_path__ + "img/bottomvector.5d7b1769.svg";